module.exports = __webpack_public_path__ + "img/timeline.9ba35c0a.png";